import React from 'react';

import { Box, Flex, Text } from '@opendoor/bricks/core';
import ContentCard from '@opendoor/bricks/deprecated/UNSAFE_layout/ContentCard';
import moment from 'moment';

import { TourRequestState } from '../../src/__generated__/internalGlobalTypes';
import { IBuyerAppointment } from '../graphql/queries/BuyerAppointments';
import { formatPhoneNumberInput } from '../helpers/formatUtils';
import { capitalCase } from '../helpers/string';
import StatusBadge, { BadgeColor } from './StatusBadge';

interface IBuyerAppointmentCardProps {
  buyerAppointment: IBuyerAppointment;
}

export const BuyerAppointmentCard: React.FC<IBuyerAppointmentCardProps> = ({
  buyerAppointment,
}) => {
  const date = moment(buyerAppointment.scheduledTime).format('l');
  const time = moment(buyerAppointment.scheduledTime).format('LT');

  return (
    <ContentCard forceBorder>
      <Flex justifyContent="space-between" alignItems="baseline" width="100%" mb={4}>
        <Box>
          <Text fontWeight="bold" fontSize="s2">
            {buyerAppointment.customer.fullName}
          </Text>
          <Text>
            {buyerAppointment.customer.email}
            {buyerAppointment.customer.phoneNumber
              ? ` • ${formatPhoneNumberInput(buyerAppointment.customer.phoneNumber)}`
              : null}
          </Text>
        </Box>
        <StatusBadge
          status={getStatus(buyerAppointment.state)}
          color={STATUS_COLOR[buyerAppointment.state]}
        />
      </Flex>
      <Flex>
        <Item label="Date" value={date} />
        <Item label="Time" value={time} />
        <Item label="Address" value={buyerAppointment.readableAddress} />
      </Flex>
    </ContentCard>
  );
};

interface IItemProps {
  label: string;
  value: string;
}

const Item: React.FC<IItemProps> = ({ label, value }) => {
  return (
    <Box mr={5} minWidth="80px">
      <Text fontWeight="bold">{label}</Text>
      <Text>{value}</Text>
    </Box>
  );
};

function getStatus(state: TourRequestState) {
  return 'Tour ' + capitalCase(state.toString());
}

export const STATUS_COLOR: { [K in TourRequestState]: BadgeColor } = {
  CANCELED: 'red',
  NO_SHOW: 'red',
  REQUESTED: 'green',
  SCHEDULED: 'green',
  COMPLETE: 'green',
};
